import React, { useState, useEffect } from 'react';
import { 
    Container, Row, Col, Card, CardHeader, CardBody, 
    Table, Button, Input, Label, UncontrolledDropdown, 
    DropdownToggle, DropdownMenu, DropdownItem, Spinner, Modal, ModalHeader, ModalBody, UncontrolledCarousel,
    Nav, NavItem, NavLink, TabContent, TabPane, Form
} from 'reactstrap';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { APIClient } from '../../helpers/api_helper';
import { toast,ToastContainer } from 'react-toastify';
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import BreadCrumb from '../../Components/Common/BreadCrumb';

const API_BASE_URL = process.env.REACT_APP_API_URL?.replace(/\/$/, '');

const TokenPlans = () => {
    document.title = "Token Plans";
    
    const [plans, setPlans] = useState([]);
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('active');
    const [selectedPlans, setSelectedPlans] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [editModal, setEditModal] = useState(false);
    const [editForm, setEditForm] = useState(null);
    const [logsModal, setLogsModal] = useState(false);
    const [purchaseLogs, setPurchaseLogs] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [userDetailsModal, setUserDetailsModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [loadingUser, setLoadingUser] = useState(false);

    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${API_BASE_URL}/tokenPlan?status=${activeTab.toUpperCase()}`, {
                headers: {
                    'Authorization': JSON.parse(sessionStorage.getItem("authUser"))?.token || '',
                    'Content-Type': 'application/json'
                }
            });

            const data = await response.json();
            
            if (data.data) {
                setPlans(data.data);
            }
        } catch (error) {
            console.error('Error fetching token plans:', error);
            toast.error('Failed to fetch token plans', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [activeTab]);

    useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = `
            .carousel {
                background-color: #f8f9fa;
            }
            
            .carousel-inner {
                height: 250px;
            }
            
            .carousel-item {
                height: 250px;
                text-align: center;
                background-color: #f8f9fa;
            }
            
            .carousel-item img {
                height: 100%;
                max-width: 100%;
                object-fit: contain;
                margin: auto;
            }
        `;
        document.head.appendChild(style);
        
        // Cleanup
        return () => document.head.removeChild(style);
    }, []);

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedPlans(plans.map(plan => plan._id));
        } else {
            setSelectedPlans([]);
        }
    };

    const handleSelect = (planId) => {
        setSelectedPlans(prev => {
            if (prev.includes(planId)) {
                return prev.filter(id => id !== planId);
            } else {
                return [...prev, planId];
            }
        });
    };

    const renderTabs = () => {
        return (
            <Nav tabs className="nav-tabs-custom mb-3">
                <NavItem>
                    <NavLink
                        className={activeTab === 'active' ? 'active' : ''}
                        onClick={() => setActiveTab('active')}
                        style={{ cursor: 'pointer' }}
                    >
                        Active Plans
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        className={activeTab === 'deleted' ? 'active' : ''}
                        onClick={() => setActiveTab('deleted')}
                        style={{ cursor: 'pointer' }}
                    >
                        Inactive Plans
                    </NavLink>
                </NavItem>
            </Nav>
        );
    };

    const renderPlansTable = () => (
        <div className="table-responsive">
            <Table className="table-striped table-nowrap align-middle mb-0">
                <thead className="table-light">
                    <tr>
                        <th scope="col">
                            <div className="form-check">
                                <Input
                                    type="checkbox"
                                    className="form-check-input"
                                    onChange={handleSelectAll}
                                    checked={selectedPlans.length === plans.length && plans.length > 0}
                                />
                            </div>
                        </th>
                        <th>Sl No</th>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Amount</th>
                        <th>No. of Tokens</th>
                        <th>Discount</th>
                        <th>Store IDs</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {plans.map((plan, index) => (
                        <tr key={plan._id}>
                            <td>
                                <div className="form-check">
                                    <Input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={selectedPlans.includes(plan._id)}
                                        onChange={() => handleSelect(plan._id)}
                                    />
                                </div>
                            </td>
                            <td>{index + 1}</td>
                            <td>{plan.name}</td>
                            <td>{plan.description?.en}</td>
                            <td>{plan.currency} {plan.amount}</td>
                            <td>{plan.noOfTokens}</td>
                            <td>{plan.discountPercentage}%</td>
                            <td>
                                <small>
                                    Apple: {plan.appleId}<br/>
                                    Google: {plan.googleId}
                                </small>
                            </td>
                            <td>
                                <div className="d-flex gap-2">
                                    <Button color="info" size="sm" onClick={() => fetchPurchaseLogs(plan._id)}>
                                        <i className="ri-file-list-line"></i>
                                    </Button>
                                    <Button color="primary" size="sm" onClick={() => fetchPlanDetails(plan._id)}>
                                        <i className="ri-pencil-line"></i>
                                    </Button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );

    const fetchPlanDetails = async (planId) => {
        try {
            setLoading(true);
            const response = await fetch(`${API_BASE_URL}/tokenPlan?planId=${planId}`, {
                headers: {
                    'Authorization': JSON.parse(sessionStorage.getItem("authUser"))?.token || '',
                    'Content-Type': 'application/json'
                }
            });

            const data = await response.json();
            
            if (data.data) {
                setEditForm(data.data);
                setEditModal(true);
            }
        } catch (error) {
            console.error('Error fetching plan details:', error);
            toast.error('Failed to fetch plan details', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            const response = await fetch(`${API_BASE_URL}/tokenPlan`, {
                method: 'PATCH',
                headers: {
                    'Authorization': JSON.parse(sessionStorage.getItem("authUser"))?.token || '',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    name: { en: editForm.name.en },
                    description: { en: editForm.description.en },
                    noOfTokens: parseInt(editForm.noOfTokens),
                    amount: parseFloat(editForm.amount),
                    appleId: editForm.appleId,
                    googleId: editForm.googleId,
                    discountPercentage: parseInt(editForm.discountPercentage),
                    planId: editForm._id
                })
            });

            const data = await response.json();
            
            if (data.message) {
                toast.success('Plan updated successfully', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                setEditModal(false);
                fetchData(); // Refresh the list
            }
        } catch (error) {
            console.error('Error updating plan:', error);
            toast.error('Failed to update plan', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } finally {
            setLoading(false);
        }
    };

    const renderEditModal = () => (
        <Modal
            isOpen={editModal}
            toggle={() => setEditModal(!editModal)}
            centered
            size="lg"
        >
            <ModalHeader toggle={() => setEditModal(!editModal)}>
                Edit Token Plan
            </ModalHeader>
            <ModalBody>
                {editForm && (
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label className="form-label">Name</Label>
                                    <Input
                                        type="text"
                                        value={editForm.name.en}
                                        onChange={(e) => setEditForm({
                                            ...editForm,
                                            name: { ...editForm.name, en: e.target.value }
                                        })}
                                        required
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label className="form-label">Description</Label>
                                    <Input
                                        type="text"
                                        value={editForm.description.en}
                                        onChange={(e) => setEditForm({
                                            ...editForm,
                                            description: { ...editForm.description, en: e.target.value }
                                        })}
                                        required
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label className="form-label">Amount</Label>
                                    <Input
                                        type="number"
                                        step="0.01"
                                        value={editForm.amount}
                                        onChange={(e) => setEditForm({
                                            ...editForm,
                                            amount: e.target.value
                                        })}
                                        required
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label className="form-label">Number of Tokens</Label>
                                    <Input
                                        type="number"
                                        value={editForm.noOfTokens}
                                        onChange={(e) => setEditForm({
                                            ...editForm,
                                            noOfTokens: e.target.value
                                        })}
                                        required
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label className="form-label">Discount Percentage</Label>
                                    <Input
                                        type="number"
                                        value={editForm.discountPercentage}
                                        onChange={(e) => setEditForm({
                                            ...editForm,
                                            discountPercentage: e.target.value
                                        })}
                                        required
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label className="form-label">Apple Store ID</Label>
                                    <Input
                                        type="text"
                                        value={editForm.appleId}
                                        onChange={(e) => setEditForm({
                                            ...editForm,
                                            appleId: e.target.value
                                        })}
                                        required
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label className="form-label">Google Play ID</Label>
                                    <Input
                                        type="text"
                                        value={editForm.googleId}
                                        onChange={(e) => setEditForm({
                                            ...editForm,
                                            googleId: e.target.value
                                        })}
                                        required
                                    />
                                </div>
                            </Col>
                        </Row>
                        <div className="text-end">
                            <Button type="submit" color="primary">
                                Update Plan
                            </Button>
                        </div>
                    </Form>
                )}
            </ModalBody>
        </Modal>
    );

    const fetchPurchaseLogs = async (planId) => {
        try {
            setLoading(true);
            const response = await fetch(`${API_BASE_URL}/tokenPlan/purchase?tokenplanId=${planId}`, {
                headers: {
                    'Authorization': JSON.parse(sessionStorage.getItem("authUser"))?.token || '',
                    'Content-Type': 'application/json'
                }
            });

            const data = await response.json();
            
            if (data.data) {
                setPurchaseLogs(data.data);
                setLogsModal(true);
            }
        } catch (error) {
            console.error('Error fetching purchase logs:', error);
            toast.error('Failed to fetch purchase logs', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } finally {
            setLoading(false);
        }
    };

    const renderLogsModal = () => (
        <Modal
            isOpen={logsModal}
            toggle={() => setLogsModal(!logsModal)}
            centered
            size="xl"
        >
            <ModalHeader toggle={() => setLogsModal(!logsModal)} className="bg-light">
                <h5 className="modal-title">Purchase History</h5>
            </ModalHeader>
            <ModalBody>
                <div className="table-responsive">
                    <Table className="table-striped table-hover align-middle mb-0">
                        <thead className="table-light">
                            <tr>
                                <th className="fw-semibold" style={{ width: '5%' }}>Sl No</th>
                                <th className="fw-semibold" style={{ width: '20%' }}>Username</th>
                                <th className="fw-semibold" style={{ width: '30%' }}>Transaction ID</th>
                                <th className="fw-semibold" style={{ width: '30%' }}>Purchase Date</th>
                                <th className="fw-semibold" style={{ width: '15%' }}>Purchase ID</th>
                            </tr>
                        </thead>
                        <tbody>
                            {purchaseLogs.map((log, index) => (
                                <tr key={log._id}>
                                    <td>{index + 1}</td>
                                    <td>
                                        <Button
                                            color="link"
                                            className="p-0 text-body fw-medium"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                fetchUserDetails(log.userId);
                                            }}
                                        >
                                            {log.username}
                                        </Button>
                                    </td>
                                    <td>
                                        <span className="badge bg-info-subtle text-info">
                                            {log.transactionId}
                                        </span>
                                    </td>
                                    <td>
                                        {moment(log.purchaseTs).format('DD MMM YYYY, hh:mm A')}
                                    </td>
                                    <td>
                                        <small className="text-muted">
                                            {log._id}
                                        </small>
                                    </td>
                                </tr>
                            ))}
                            {purchaseLogs.length === 0 && (
                                <tr>
                                    <td colSpan="5" className="text-center py-4 text-muted">
                                        <i className="ri-information-line fs-4 me-1 align-middle"></i>
                                        No purchase history found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
                {purchaseLogs.length > 0 && (
                    <div className="text-muted mt-3 text-center">
                        <small>Showing {purchaseLogs.length} purchase records</small>
                    </div>
                )}
            </ModalBody>
        </Modal>
    );

    const fetchUserDetails = async (userId) => {
        try {
            setLoadingUser(true);
            const authUser = JSON.parse(sessionStorage.getItem("authUser"));
            const contactMasked = authUser?.userContactMasked ? 1 : 0;
            
            const response = await APIClient.get(`/python/users/?userId=${userId}&contactMasked=${contactMasked}`);
            if (response.data && response.data.result && response.data.result.length > 0) {
                setSelectedUser(response.data.result[0]);
                setUserDetailsModal(true);
            }
        } catch (error) {
            console.error('Error fetching user details:', error);
            toast.error('Failed to fetch user details', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } finally {
            setLoadingUser(false);
        }
    };

    const getImageUrl = (url) => {
        if (!url) return '/images/default-avatar.png';
        if (url.startsWith('http')) return url;
        
        const baseUrl = process.env.REACT_APP_MEDIA_URL.replace(/\/$/, '');
        const imagePath = url.replace(/^\//, '');
        return `${baseUrl}/${imagePath}`;
    };

    const renderUserDetailsModal = () => (
            <Modal
                isOpen={userDetailsModal}
                toggle={() => setUserDetailsModal(!userDetailsModal)}
                size="lg"
            >
                <ModalHeader toggle={() => setUserDetailsModal(!userDetailsModal)}>
                    User Details
                </ModalHeader>
                <ModalBody>
                    {loadingUser ? (
                        <div className="text-center">
                            <Spinner color="success"> Loading... </Spinner>
                        </div>
                    ) : selectedUser && (
                        <div>
                            {/* Images Carousel with controlled height */}
                            {selectedUser.profilePic && selectedUser.profilePic.length > 0 && (
                                <div className="mb-4" style={{ maxHeight: '250px', overflow: 'hidden' }}>
                                    <UncontrolledCarousel
                                        interval={4000}
                                        items={selectedUser.profilePic
                                            .filter(pic => pic.type === 'PHOTO')
                                            .map((pic, index) => ({
                                                altText: `${selectedUser.firstName}'s photo`,
                                                caption: ' ',
                                                key: index + 1,
                                                src: getImageUrl(pic.url),
                                                style: {
                                                    height: '250px',
                                                    objectFit: 'contain',
                                                    backgroundColor: '#f8f9fa'
                                                }
                                            }))}
                                        indicators={true}
                                        controls={true}
                                    />
                                </div>
                            )}

                            {/* User Information */}
                                <Row>
                                    <Col md={6}>
                                <h5 className="text-muted mb-3">Basic Information</h5>
                                <Table className="table-borderless">
                                                    <tbody>
                                                        <tr>
                                            <th>Full Name</th>
                                                            <td>{selectedUser.firstName} {selectedUser.lastName}</td>
                                                        </tr>
                                                        <tr>
                                            <th>Username</th>
                                                            <td>{selectedUser.username}</td>
                                                        </tr>
                                                        <tr>
                                            <th>Email</th>
                                                            <td>{selectedUser.email}</td>
                                                        </tr>
                                                        <tr>
                                            <th>Phone</th>
                                                            <td>{selectedUser.countryCode} {selectedUser.phoneNumber}</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                    </Col>
                                    <Col md={6}>
                                <h5 className="text-muted mb-3">Additional Information</h5>
                                <Table className="table-borderless">
                                                    <tbody>
                                                        <tr>
                                            <th>Status</th>
                                                            <td>
                                                                <span className={`badge bg-${selectedUser.statusText === 'ACTIVE' ? 'success' : 'danger'}`}>
                                                                    {selectedUser.statusText}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                            <th>Token Balance</th>
                                                            <td>{selectedUser.tokenBalance}</td>
                                                        </tr>
                                                        <tr>
                                            <th>Likes Count</th>
                                                            <td>{selectedUser.likesCount}</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                            </Col>
                        </Row>
                    </div>
                )}
            </ModalBody>
        </Modal>
    );

    return (
        <div className="page-content">
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            <Container fluid>
                <BreadCrumb title="Token Plans" pageTitle="Plans" />

                {renderTabs()}

                <TabContent activeTab={activeTab}>
                    <TabPane tabId="active">
                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <CardHeader>
                                        <div className="d-flex align-items-center">
                                            <h5 className="card-title mb-0 flex-grow-1">Token Plans</h5>
                                            <div className="d-flex gap-2">
                                                <Button color="primary" onClick={() => {}}>
                                                    <i className="ri-add-line align-bottom me-1"></i> Add Plan
                                                </Button>
                                            </div>
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        {loading ? (
                                            <div className="text-center mt-3">
                                                <Spinner color="primary" />
                                            </div>
                                        ) : (
                                            renderPlansTable()
                                        )}
                                    </CardBody>
                                </Card>
                                    </Col>
                                </Row>
                    </TabPane>

                    <TabPane tabId="deleted">
                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <CardHeader>
                                        <h5 className="card-title mb-0">Inactive Token Plans</h5>
                                    </CardHeader>
                                    <CardBody>
                                        {loading ? (
                                            <div className="text-center mt-3">
                                                <Spinner color="primary" />
                            </div>
                                        ) : (
                                            renderPlansTable()
                                        )}
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </TabPane>
                </TabContent>
            </Container>
            {renderEditModal()}
            {renderLogsModal()}
            {renderUserDetailsModal()}
        </div>
    );
};

export default TokenPlans;